import { gql } from '@apollo/client'

export const CREATE_ANCILLARY = gql`
  mutation CreateAncillary($input: CreateAncillaryInput!) {
    createAncillary(input: $input)
  }
`

export const EDIT_ANCILLARY = gql`
  mutation EditAncillary($input: ChangeAncillaryInput!) {
    changeAncillary(input: $input)
  }
`

export const ACTIVATE_ANCILLARY = gql`
  mutation ActivateAncillary($input: EnableAncillaryInput!) {
    enableAncillary(input: $input)
  }
`

export const DEACTIVATE_ANCILLARY = gql`
  mutation DeactivateAncillary($input: DisableAncillaryInput!) {
    disableAncillary(input: $input)
  }
`

export const ACTIVATE_ADDON_SERVICE = gql`
  mutation ActivateAddonService($enableInput: EnableServiceFeeAddonRuleInput!) {
    enableServiceFeeAddonRule(input: $enableInput)
  }
`

export const ACTIVATE_LOCAL_ADDON_SERVICE = gql`
  mutation ActivateLocalAddonService($addonService: AddonService!) {
    activateAddonService(addonService: $addonService) @client
  }
`

export const DEACTIVATE_ADDON_SERVICE = gql`
  mutation DeactivateAddonService($disableInput: DisableServiceFeeAddonRuleInput!) {
    disableServiceFeeAddonRule(input: $disableInput)
  }
`

export const DEACTIVATE_LOCAL_ADDON_SERVICE = gql`
  mutation DeactivateLocalAddonService($addonService: AddonService!) {
    deactivateAddonService(addonService: $addonService) @client
  }
`

export const CHANGE_COMPANY_INSURANCE_SETTINGS = gql`
  mutation ChangeCompanyInsuranceSettings($settings: ChangeCompanyInsuranceSettingsInput!) {
    changeCompanyInsuranceSettings(input: $settings)
  }
`
